import { auth } from './firebaseAuth';

/** Ana sayfa akışının bir sayfası (`/api/home-feed`); oturum belirteci başlıkta gider. */
export async function fetchHomeFeed(
  cursor: string | null,
  signal?: AbortSignal,
): Promise<LeagueFeed.HomePage> {
  const user = auth.currentUser;
  if (!user) throw new Error('Giriş yapmalısın.');
  const token = await user.getIdToken();
  const params = new URLSearchParams(cursor ? { cursor } : {});
  const response = await fetch(`/api/home-feed${cursor ? `?${params}` : ''}`, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });
  if (!response.ok) throw new Error(String(response.status));
  return response.json();
}
